import {Module} from "vuex";
import {RootState} from "@/store/index";
import jwt_decode from "jwt-decode";

export interface AuthModuleState {
  accessToken: string;
  refreshToken: string;
  nickName: string;
  userIcon: number;
  allowMenu: Array<string> | null;
  denyEtc: Array<string> | null;
}

export const AuthModule: Module<AuthModuleState, RootState> = {
  namespaced: true,
  state: {
    accessToken: "",
    refreshToken: "",
    nickName: "",
    userIcon: 0,
    allowMenu: null,
    denyEtc: null,
  },
  mutations: {
    setAccessToken(state, payload): void {
      if (payload) {
        localStorage.setItem("accessToken", payload);
      } else {
        localStorage.removeItem("accessToken");
      }
      state.accessToken = payload;
    },
    setRefreshToken(state, payload): void {
      if (payload) {
        localStorage.setItem("refreshToken", payload);
      } else {
        localStorage.removeItem("refreshToken");
      }
      state.refreshToken = payload;
    },
    setNickName(state, payload): void {
      state.nickName = payload;
    },
    setUserIcon(state, payload): void {
      state.userIcon = payload;
    },
    setAllowMenu(state, payload): void {
      state.allowMenu = payload;
    },
    setDenyEtc(state, payload): void {
      state.denyEtc = payload;
    },
  },
  actions: {
    setToken(state, payload): void {
      if (payload.accessToken === null) return;

      try {
        if (payload.accessToken) {
          const decodedToken: any = state.getters.getJwtDecode(payload.accessToken);

          if (decodedToken === false) return;

          state.commit("setAccessToken", payload.accessToken);
        }

        if (payload.refreshToken) {
          state.commit("setRefreshToken", payload.refreshToken);
        }
      } catch (error) {
        console.error(error);
      }
    },
    setUser(state, payload): void {
      if (!payload) return;

      state.commit("setNickName", payload.nickName);
      state.commit("setUserIcon", payload.userIcon);
      state.commit("setAllowMenu", payload.allowMenu);
      state.commit("setDenyEtc", payload.denyEtc);
    },
    refreshToken(state, payload): void {
      if (payload.accessToken) state.commit("setAccessToken", payload.accessToken);
      if (payload.refreshToken) state.commit("setRefreshToken", payload.refreshToken);
    },
    removeToken(state): void {
      state.commit("setAccessToken", "");
      state.commit("setRefreshToken", "");
      state.commit("setNickName", "");
      state.commit("setUserIcon", 0);
      state.commit("setAllowMenu", null);
      state.commit("setDenyEtc", null);
    },
  },
  getters: {
    // vuex-persistedstate에 의해서 state 값이 vue devtools에서 갱신되지 않아 getter로 체크하기 위함
    getState(state): any {
      return state;
    },
    getJwtDecode:
      () =>
      (payload: any): any => {
        if (payload.length === 0) return false;

        const decodedToken: any = jwt_decode(payload);

        if (decodedToken.UUID === undefined) return false;

        return decodedToken;
      },
  },
};
